// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Modal Subir Documento — alineado con detalle comprobante */

/* Un poco más ancho que modal-lg / dialogWide genérico para acomodar lista de archivos */
.uploadModal_uploadModalDialog__mseOF {
  max-width: min(96vw, 1180px);
  width: 100%;
}

/* Más aire que bodyWrap del detalle comprobante (0.5rem lateral) */
.uploadModal_uploadContent__68vwt {
  background: #fff;
  max-height: min(78vh, 920px);
  overflow-y: auto;
  padding: 1.65rem clamp(1rem, 3.5vw, 2.5rem);
  box-sizing: border-box;
}

.uploadModal_guideSection__XATe- {
  margin-top: 1.75rem;
  padding-top: 1.25rem;
  border-top: 1px solid #e9ecef;
}

.uploadModal_dropZoneBanner__Z3PRb {
  display: flex;
  align-items: flex-start;
  gap: 0.95rem;
  margin-bottom: 1.35rem;
  padding: 1rem 1.15rem;
  border: 2px dashed #cbd5e1;
  border-radius: 10px;
  background: #f9fafb;
  font-size: 14px;
  color: #374151;
  line-height: 1.55;
}

.uploadModal_dropZoneIcon__krpVG {
  color: #4f46e5;
  font-size: 22px;
  flex-shrink: 0;
  margin-top: 2px;
}

.uploadModal_metaBlock__dPyd\\+ {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  margin-bottom: 1.35rem;
}

.uploadModal_metaRow__fP8fv {
  display: grid;
  grid-template-columns: minmax(180px, 34%) 1fr;
  gap: 0.65rem 1.25rem;
  align-items: baseline;
}

.uploadModal_metaLabel__5a7a5 {
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  letter-spacing: 0.02em;
}

.uploadModal_metaValue__whZsL {
  font-size: 13px;
  color: #111827;
  font-weight: 500;
}

.uploadModal_metaPill__0HDHp {
  display: inline-block;
  padding: 0.25rem 0.65rem;
  border-radius: 6px;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
}

.uploadModal_metaSelect__FcXnd {
  width: 100%;
  min-height: 2.35rem;
  padding: 0.45rem 0.65rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #fff;
  color: #111827;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.35;
}

.uploadModal_metaSelect__FcXnd:focus {
  outline: none;
  border-color: #818cf8;
  box-shadow: 0 0 0 3px rgba(129, 140, 248, 0.22);
}

/* Sección “Archivos — …”: título arriba, inputs en rejilla horizontal */
.uploadModal_fileSection__phfxv {
  margin-top: 0.35rem;
  margin-bottom: 0.6rem;
}

.uploadModal_fileFieldsGrid__QtQFh {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1.1rem 1.5rem;
  align-items: stretch;
}

/* Pantallas muy estrechas: una columna como antes */
@media (max-width: 640px) {
  .uploadModal_fileFieldsGrid__QtQFh {
    grid-template-columns: 1fr;
  }
}

/* Campos pueden crecer a la misma altura dentro de cada celda */
.uploadModal_fileFieldsGrid__QtQFh > * {
  min-width: 0;
}

.uploadModal_sectionSubtitle__ZLBoV {
  font-size: 1rem;
  font-weight: 600;
  color: #111827;
  margin: 0 0 0.9rem;
  padding-bottom: 0.45rem;
  border-bottom: 1px solid #e5e7eb;
}

.uploadModal_fileSection__phfxv > .uploadModal_sectionSubtitle__ZLBoV:first-child {
  margin-top: 0.25rem;
}

.uploadModal_guideSection__XATe- > .uploadModal_sectionSubtitle__ZLBoV {
  margin-top: 0;
}

.uploadModal_guideSection__XATe- .uploadModal_fileFieldsGrid__QtQFh {
  margin-top: 0.35rem;
}

.uploadModal_footerBar__Y1Pmr {
  border-top: 1px solid #e5e7eb;
  padding: 1.15rem clamp(1rem, 3.5vw, 2.5rem) 1.25rem;
  margin-top: 0.5rem;
}

.uploadModal_footerActions__wGFZ3 {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 0.5rem;
  align-items: center;
}
`, "",{"version":3,"sources":["webpack://./src/modals/upload_modal/uploadModal.module.css"],"names":[],"mappings":"AAAA,6DAA6D;;AAE7D,yFAAyF;AACzF;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA,mEAAmE;AACnE;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,6CAA6C;EAC7C,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA,wEAAwE;AACxE;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,oDAAoD;AACpD;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,gEAAgE;AAChE;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,mDAAmD;EACnD,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,mBAAmB;AACrB","sourcesContent":["/* Modal Subir Documento — alineado con detalle comprobante */\n\n/* Un poco más ancho que modal-lg / dialogWide genérico para acomodar lista de archivos */\n.uploadModalDialog {\n  max-width: min(96vw, 1180px);\n  width: 100%;\n}\n\n/* Más aire que bodyWrap del detalle comprobante (0.5rem lateral) */\n.uploadContent {\n  background: #fff;\n  max-height: min(78vh, 920px);\n  overflow-y: auto;\n  padding: 1.65rem clamp(1rem, 3.5vw, 2.5rem);\n  box-sizing: border-box;\n}\n\n.guideSection {\n  margin-top: 1.75rem;\n  padding-top: 1.25rem;\n  border-top: 1px solid #e9ecef;\n}\n\n.dropZoneBanner {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.95rem;\n  margin-bottom: 1.35rem;\n  padding: 1rem 1.15rem;\n  border: 2px dashed #cbd5e1;\n  border-radius: 10px;\n  background: #f9fafb;\n  font-size: 14px;\n  color: #374151;\n  line-height: 1.55;\n}\n\n.dropZoneIcon {\n  color: #4f46e5;\n  font-size: 22px;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.metaBlock {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n  margin-bottom: 1.35rem;\n}\n\n.metaRow {\n  display: grid;\n  grid-template-columns: minmax(180px, 34%) 1fr;\n  gap: 0.65rem 1.25rem;\n  align-items: baseline;\n}\n\n.metaLabel {\n  font-size: 11px;\n  font-weight: 600;\n  color: #6b7280;\n  letter-spacing: 0.02em;\n}\n\n.metaValue {\n  font-size: 13px;\n  color: #111827;\n  font-weight: 500;\n}\n\n.metaPill {\n  display: inline-block;\n  padding: 0.25rem 0.65rem;\n  border-radius: 6px;\n  background: #f3f4f6;\n  border: 1px solid #e5e7eb;\n}\n\n.metaSelect {\n  width: 100%;\n  min-height: 2.35rem;\n  padding: 0.45rem 0.65rem;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  background: #fff;\n  color: #111827;\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.35;\n}\n\n.metaSelect:focus {\n  outline: none;\n  border-color: #818cf8;\n  box-shadow: 0 0 0 3px rgba(129, 140, 248, 0.22);\n}\n\n/* Sección “Archivos — …”: título arriba, inputs en rejilla horizontal */\n.fileSection {\n  margin-top: 0.35rem;\n  margin-bottom: 0.6rem;\n}\n\n.fileFieldsGrid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1.1rem 1.5rem;\n  align-items: stretch;\n}\n\n/* Pantallas muy estrechas: una columna como antes */\n@media (max-width: 640px) {\n  .fileFieldsGrid {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Campos pueden crecer a la misma altura dentro de cada celda */\n.fileFieldsGrid > * {\n  min-width: 0;\n}\n\n.sectionSubtitle {\n  font-size: 1rem;\n  font-weight: 600;\n  color: #111827;\n  margin: 0 0 0.9rem;\n  padding-bottom: 0.45rem;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.fileSection > .sectionSubtitle:first-child {\n  margin-top: 0.25rem;\n}\n\n.guideSection > .sectionSubtitle {\n  margin-top: 0;\n}\n\n.guideSection .fileFieldsGrid {\n  margin-top: 0.35rem;\n}\n\n.footerBar {\n  border-top: 1px solid #e5e7eb;\n  padding: 1.15rem clamp(1rem, 3.5vw, 2.5rem) 1.25rem;\n  margin-top: 0.5rem;\n}\n\n.footerActions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 0.5rem;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"uploadModalDialog": `uploadModal_uploadModalDialog__mseOF`,
	"uploadContent": `uploadModal_uploadContent__68vwt`,
	"guideSection": `uploadModal_guideSection__XATe-`,
	"dropZoneBanner": `uploadModal_dropZoneBanner__Z3PRb`,
	"dropZoneIcon": `uploadModal_dropZoneIcon__krpVG`,
	"metaBlock": `uploadModal_metaBlock__dPyd+`,
	"metaRow": `uploadModal_metaRow__fP8fv`,
	"metaLabel": `uploadModal_metaLabel__5a7a5`,
	"metaValue": `uploadModal_metaValue__whZsL`,
	"metaPill": `uploadModal_metaPill__0HDHp`,
	"metaSelect": `uploadModal_metaSelect__FcXnd`,
	"fileSection": `uploadModal_fileSection__phfxv`,
	"fileFieldsGrid": `uploadModal_fileFieldsGrid__QtQFh`,
	"sectionSubtitle": `uploadModal_sectionSubtitle__ZLBoV`,
	"footerBar": `uploadModal_footerBar__Y1Pmr`,
	"footerActions": `uploadModal_footerActions__wGFZ3`
};
export default ___CSS_LOADER_EXPORT___;
